import React from 'react';
import { Share2, Users } from 'lucide-react';
import EmptyState from '../ui/EmptyState';
import Button from '../ui/Button';
import { useLanguage } from '../../contexts/LanguageContext';

function ReferralInviteEmptyState({ onOpenPrograms, className = '' }) {
  const { t } = useLanguage();
  const n = t.enrola.network;

  return (
    <EmptyState
      className={className}
      icon={Users}
      title={n.noInviteesTitle}
      description={n.noInviteesDesc}
      action={
        onOpenPrograms ? (
          <Button onClick={onOpenPrograms} icon={Share2}>
            {n.shareMyLink}
          </Button>
        ) : null
      }
    />
  );
}

export default ReferralInviteEmptyState;
